module.exports = __webpack_public_path__ + "img/Realisme_Andre_kunstformer_Grieg.2bd7efff.jpg";